export const LogoHeader = ({ logo, name, tagline }) => (
    <>
      <img className="restaurant-logo" src={logo} alt="Logo" />
      <div className="logo">{name}</div>
      <div className="tagline">{tagline}</div>
    </>
);